import { Directive, AfterViewInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appDropdown]'
})
export class DropdownDirective implements AfterViewInit {
  @Input('direction') direction: string = 'auto';
  @Input('placeholder') placeholder: string = 'auto';
  @Output() onSelectItem = new EventEmitter<string>();
  @Output() onSelectValue = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    ($(this.elementRef.nativeElement) as any).dropdown({
      direction: this.direction,
      placeholder: this.placeholder,
      message: {
        addResult: 'Adicionar <b>{term}</b>?',
        count: '{count} selecionados.',
        maxSelections: 'Máximo {maxCount} selecionados.',
        noResults: 'Nenhum resultado encontrado.'
      },
      onChange: (value, text) => {
        this.onSelectItem.emit(value);
        this.onSelectValue.emit(text);
      }
    });
  }
}
